import { Ban, Mail } from "lucide-react";

export function SuspendedAccountCard() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="flex flex-col items-center gap-4 max-w-md text-center px-6">
        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-orange-50">
          <Ban className="w-8 h-8 text-orange-500" />
        </div>
        <h2 className="text-xl font-semibold text-neutral-900">Account Suspended</h2>
        <p className="text-sm text-neutral-500 leading-relaxed">
          Your account has been suspended. You are unable to access this application until your
          account is reactivated. Please contact your administrator for more information.
        </p>
        <a
          href="mailto:support@skypointcloud.com"
          className="inline-flex items-center gap-2 mt-2 px-4 py-2 text-sm font-medium text-white bg-brand-600 hover:bg-brand-700 rounded-md transition-colors"
        >
          <Mail className="w-4 h-4" />
          Contact Support
        </a>
      </div>
    </div>
  );
}
